module.exports = __webpack_public_path__ + "83b4cf771ad0c0c30edb97576ea02ee5.svg";